module.exports = __webpack_public_path__ + "static/img/1084.22bbbee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1084.jpg
// module id = 266
// module chunks = 0